import React from 'react';
import clsx from 'clsx';

import { ProgressBar as StyledProgressBar, Track, Progress } from './wrappers';

interface IProgressBar {
  progress: number;
  small?: boolean;
}

const ProgressBar = ({ progress, small }: IProgressBar) => (
  <StyledProgressBar className={clsx(small && 'small')}>
    <Track>
      <Progress style={{ width: `${progress * 100}%` }} />
    </Track>
  </StyledProgressBar>
);

export default ProgressBar;
